import React, { StatelessComponent } from 'react';
import { Illustration, IllustrationSizeProps } from './illustration';
import src from '!svg-url-loader?noquotes=true!grpn-mx-mixer/dist/images/icons/merchant-logo-horizontal.svg';

export const IllustrationMerchantLogoHorizontal: StatelessComponent<IllustrationSizeProps> = (
  props: IllustrationSizeProps,
) => <Illustration src={src} {...props} />;
